export default __webpack_public_path__ + "static/media/darkAvatar.775383c1.svg";